module.exports = __webpack_public_path__ + "img/facebook_btn.5b9a41d4.png";